@let urgentNotifications = _serviceNotificationsCardsService.urgentNotifications();

<bw-spinner-legacy *ngIf="!urgentNotifications"></bw-spinner-legacy>

<div
  *ngIf="urgentNotifications && urgentNotifications.length > 0"
  class="carousel"
  (mouseenter)="pauseCarousel()"
  (mouseleave)="resumeCarousel()"
>
  <div
    class="carousel-track"
    [style.transform]="'translateX(-' + currentIndex * 100 + '%)'"
    [style.transition]="'transform 400ms ease'"
  >
    <div class="carousel-slide" *ngFor="let notification of urgentNotifications">
      <brightside-web-urgent-notification
        [notificationItem]="notification">
      </brightside-web-urgent-notification>
    </div>
  </div>

  <div class="carousel-dots">
    <bw-icon-legacy (click)="prev()" [iconName]="'chevron_left'"></bw-icon-legacy>
    <span
      *ngFor="let item of urgentNotifications; let i = index"
      (click)="goTo(i)"
      [class.active]="i === currentIndex"
    ></span>
    <bw-icon-legacy (click)="next()" [iconName]="'chevron_right'"></bw-icon-legacy>
  </div>
</div>
